
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.7154 15.395L13.3724 12.052L13.3715 12.0511C15.79 8.93547 15.3697 4.47648 12.4116 1.86765C9.45351 -0.741177 4.97696 -0.600893 2.18803 2.18803C-0.600893 4.97696 -0.741177 9.45351 1.86765 12.4116C4.47648 15.3697 8.93547 15.79 12.0511 13.3715L15.3941 16.7145C15.6283 16.9574 15.9755 17.055 16.302 16.9697C16.6285 16.8845 16.8837 16.6297 16.9694 16.3033C17.0551 15.9769 16.958 15.6296 16.7154 15.395ZM12.4549 10.4041C11.4541 12.1376 9.60443 13.2055 7.60276 13.2055C4.50844 13.2055 2 10.6971 2 7.60276C2 4.50844 4.50844 2 7.60276 2C9.60443 2 11.4541 3.06788 12.4549 4.80138C13.4557 6.53488 13.4557 8.67064 12.4549 10.4041Z","fill":"#357D67"}})])
          )
        }
      }
    